import store from "@/store/index";

const notification = {
  success(message: string) {
    store.dispatch("shared/showSnackbar", {
      message: message,
      color: "success",
    });
  },

  error(message: string) {
    store.dispatch("shared/showSnackbar", {
      message: message,
      color: "error",
    });
  },
  warn(message: string) {
    store.dispatch("shared/showSnackbar", {
      message: message,
      color: "warning",
    });
  },
  info(message: string) {
    store.dispatch("shared/showSnackbar", {
      message: message,
      color: "info",
    });
  },
  hide() {
    store.dispatch("shared/hideSnackbar", {
      message: "",
      color: "",
    });
  },
};

export default notification;
